<script>
  import { onMount } from "svelte";
  import ListRow from "./Components/ListRow.svelte";
  import { getLists, getSegments, validate } from "./static";
  import {External, M} from "../external";

  export let data, next, cache;
  let lists = [],
    segments = [];

  function onChange(id, checked, isExcluded, isSegment = false) {
    let list = !isSegment ? data.data.lists : data.data.segments;

    if (checked) {
      let index = -1;

      if (list.length > 0) {
        for (let item in list) {
          if (list.hasOwnProperty(item) && list[item].id === id) {
            index = item;
            list[item].excluded = isExcluded;
            break;
          }
        }
      }

      if (index === -1) {
        list.push({ id: id, excluded: isExcluded });
      }
    } else {
      list = list.filter(function (item) {
        return item.id !== id;
      });
    }

    if (!isSegment) {
      data.data.lists = list;
    } else {
      data.data.segments = list;
    }
  }

  let onSegmentChange = (id, checked, isExcluded) => {
    onChange(id, checked, isExcluded, true);
  };

  let onNext = () => {
    if (!validate("recipients", data)) {
      return;
    }

    next();
  };

  onMount(function () {
    function selectLists(allLists, currentList) {
      for (let i = 0; i < currentList.length; i++) {
        let selectedList = External.getById(allLists, currentList[i].id);
        if (selectedList != null) {
          currentList[i] = Object.assign({}, currentList[i], {
            isChecked: true,
            isExcluded: selectedList.excluded
          });
        }
      }
    }

    getLists(function (result) {
      lists = result;
      cache.lists = result;

      selectLists(data.data.lists, lists);
    });

    getSegments(function (result) {
      segments = result;
      cache.segments = result;

      selectLists(data.data.segments, segments);
    });
  });

  $: {
    if (!data.data) data.data = {};
    if (!data.data.lists) data.data.lists = [];
    if (!data.data.segments) data.data.segments = [];
  }
</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper" />
      </div>
    </div>

    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15"><span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> dvr </span></div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.SELECT_AUDIENCE}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.SELECT_AUDIENCE_DESC}</div>
            <div class="col20 f-left email-list-wrapper-outer">
              <div class="col20 f-left t-center mb-15">
                <h4 class="t-left email-audience-group-separator">{M.LISTS}</h4>
              </div>
              {#if lists.length > 0}
                {#each lists as list (list)}
                  <ListRow bind:data={list} onChange={onChange} />
                {/each}
              {:else}
                <h5>{M.NO_LISTS}</h5>
              {/if}

              <div class="col20 f-left t-center mb-15 mt-35">
                <h4 class="t-left email-audience-group-separator">{M.SEGMENTS}</h4>
              </div>
              {#if segments.length > 0}
                {#each segments as list (list)}
                  <ListRow bind:data={list} onChange={onSegmentChange} />
                {/each}
              {:else}
                <h5>{M.NO_SEGMENTS}</h5>
              {/if}
            </div>
            <div class="col20 f-left flex justify-center mt-35">
              <a data-action="nextPage" on:click={onNext} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;"
                >{M.NEXT}
                →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
